import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'
import {
	type HttpUpdateExperienceCoverPhotoOptions,
	httpUpdateExperienceCoverPhoto
} from '../http/experience-vetting.http'

export const useUpdateExperiencVettingCoverPhoto = (
	urlParams: Omit<
		HttpUpdateExperienceCoverPhotoOptions['urlParams'],
		'imageId'
	>,
	options?: UseMutationOptions<
		unknown,
		unknown,
		HttpUpdateExperienceCoverPhotoOptions['payload'] &
			Pick<HttpUpdateExperienceCoverPhotoOptions['urlParams'], 'imageId'>
	>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: (payload) =>
			httpUpdateExperienceCoverPhoto({
				urlParams: { ...urlParams, imageId: payload.imageId },
				payload,
				params: {
					responseType: 'extended'
				}
			}),
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		},
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.setQueriesData(
				{
					queryKey: [
						QUERY_KEYS.EXPERIENCE_VETTING,
						urlParams.experienceId
					]
				},
				data
			)
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
